import queuePresenting from "../../../queuePresenting";
import "../../../jquery.mask";

queuePresenting(0);

$(document).ready(function () {
    $(".titulo-pergunta").on("click", function () {
        let estadoIcon = $(this).find(".seta").data("estado");
        if (estadoIcon == 0) {
            $(this).find(".seta").removeClass("icon-arrowdown").addClass("icon-arrowup");
            $(this).find(".seta").data("estado", "1");
        } else {
            $(this).find(".seta").removeClass("icon-arrowup").addClass("icon-arrowdown");
            $(this).find(".seta").data("estado", "0");
        }
    });

    $('#pesquisaConfiguracao').on('keyup', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var pesquisa = $('#pesquisaConfiguracao').val().toLowerCase();
        var saltar = 0;
        var collapseIn = $('#perguntasFrequentes').find('li.collapse.in');

        $(".titulo-pergunta").not('.collapsed').addClass('collapsed');
        $('#perguntasFrequentes').find('.perguntas').removeClass('hidden');
        $('#perguntasFrequentes').find('.no-results').addClass('hidden');
        collapseIn.removeClass('in');
        collapseIn.prev('li').children().removeClass('icon-arrowup').addClass('icon-arrowdown');
        collapseIn.prev('li').children().data("estado", "0");
        $('#perguntasFrequentes').find('li.titulo-pergunta').removeClass('hidden');
        var previousObj;

        $('#perguntasFrequentes').find('li').each(function () {
            if (saltar == 1) {
                saltar = 0;
                return;
            }
            if (typeof $(this).data('descricao') !== 'undefined') {
                if ($(this).data('descricao').indexOf(pesquisa) > -1) {

                    if ($(this).hasClass("titulo-pergunta")) {
                        saltar = 1;
                    } else {
                        previousObj.removeClass('hidden');
                    }
                } else {
                    previousObj = $(this).closest('li.titulo-pergunta');
                    previousObj.addClass('hidden');
                }
            }
        });
        if ($('#perguntasFrequentes').find('ul li:visible').html().length == 0) {
            $('#perguntasFrequentes').find('.no-results').removeClass('hidden');
            $('#perguntasFrequentes').find('.perguntas').addClass('hidden');
        }

    });

});
